// 本地存储 sessionStorage
const sessionStorage = window.sessionStorage
export const session = {
  getItem: function (key) {
    return sessionStorage.getItem(key)
  },
  setItem: function (key, value) {
    sessionStorage.setItem(key, value)
  },
  remove: function (key) {
    if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key)
    }
  },
  clear: function () {
    sessionStorage.clear()
  },
  setObject: function (key, object) {
    sessionStorage.setItem(key, JSON.stringify(object))
  },
  getObject: function (key) {
    return JSON.parse(sessionStorage.getItem(key))
  }
}
